import { PDFViewer } from '@react-pdf/renderer';
import LeaseLicense from 'lib/components/practitioners/lease-license';
import React from 'react'


const LicenceViewer = () => {
  return (
    <PDFViewer width="100%" height="1000px">
      <LeaseLicense
        licenseDate="2025-07-01"
        licenseeName="Rishi Mishra"
        licenseeAddress="123, Sample Street, Mumbai"
        designatedHours="9am - 5pm"
        licenseFee={1000}
        consultingRoom="Room 203"
        licensePeriodStart="2025-08-01"
        carParkingFee={true}
        terminationDate="2026-07-31"
      />
    </PDFViewer>
  );
};

export default LicenceViewer